export const getLocations = async (keyword) => {
  const url = 'https://www.routerunnersautotransport.com/api/zipcodes';
  const response = await fetch(url, {
    method: 'post',
    body: JSON.stringify({
      keyword
    }),
    headers: {
      'Content-Type': 'application/json'
    }
  });
  const body = await response.json();

  let locations = [];
  if (body) {
    locations = body.map((obj) => {
      let { zip } = obj;
      if (
        typeof obj.zip === 'string' &&
        obj.zip.length === 6 &&
        obj.zip.charAt(0) === '0'
      ) {
        zip = obj.zip.substring(1);
      }
      return { ...obj, zip };
    });
  }
  return locations;
};

export const getMake = async (year) => {
  const url = 'https://www.routerunnersautotransport.com/api/vehicles/makes';
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      year: `${year}`
    }),
    headers: {
      'Content-Type': 'application/json'
    }
  });
  const makes = await response.json();

  let body = '';
  makes.forEach((make) => {
    body += `<option value="${make}">${make}</option>`;
  });

  return body;
};

export const getModel = async (year, make) => {
  const url = 'https://www.routerunnersautotransport.com/api/vehicles/models';
  const response = await fetch(url, {
    method: 'post',
    body: JSON.stringify({
      year: `${year}`,
      make
    }),
    headers: {
      'Content-Type': 'application/json'
    }
  });
  const models = await response.json();

  let body = '';
  models.forEach((model) => {
    body += `<option value="${model}">${model}</option>`;
  });

  return body;
};
